import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Container } from "../../atoms/container/Container";
import { Text } from "../../atoms/text/Text";
import { AddressCard } from "../../molecules/addressCard/AddressCard";
import style from "../pickupLocation/pickupLocation.module.scss";
import { Icon } from "../../icon/Icon";
import { AddressModal } from "../../molecules/addressModal/AddressModal";
import { useCustomDropLocation } from "../../../hooks/useCustomDropLocation/useCustomDropLocation";
interface PickupLocationProps {
    handleAddressSelection: any;
    pickupLocation: any;
}

export const CustomDropLocation: React.FC<PickupLocationProps> = ({
    handleAddressSelection,
    pickupLocation
}) => {
    const {
        formattedAddress,
        isOpen,
        handleCancel,
        address1,
        address2,
        setAddress2,
        setAddress1,
        landmark,
        setLandmark,
        ambulanceAvailable,
        setAmbulanceAvailable,
        liftAvailable,
        setLiftAvailable,
        autocompleteSuggestions,
        handleInputChange,
        handleSuggestionClick,
        saveAddress,
        handleOpenModal,
        CurrentLocation,
        handleCustomAddressSelection
    } = useCustomDropLocation({ handleAddressSelection });
    return (
        <>
            <BackgroundWrapper className={style.background}>
                <Container>
                    <Text text="Live Location" className={`${style.address_title} ${style.space}`} />
                </Container>
                <Container className={style.address_wrapper}>
                    <div>
                        <Container className={style.addressCard}>
                            {CurrentLocation.map((address: any, index: number) => (
                                <>
                                    <AddressCard
                                        count={index + 1}
                                        key={index + 1}
                                        leftSideIcon="/images/home.png"
                                        rightSideBadgeText={["Partnered"]}
                                        address={{ ...address, location: { coordinates: [address?.geoLocation?.coordinates?.[1], address?.geoLocation?.coordinates?.[0]] } }}
                                        handleAddressSelection={handleCustomAddressSelection}
                                        selectedAddress={null}
                                        pickupLocation={pickupLocation}
                                    />
                                </>
                            ))}
                        </Container>
                        <Container className={style.card}>
                            <div onClick={handleOpenModal} className={style.icon}>
                                <Icon className={style.icon_prop} src="/images/plus.png" alt="Plus Icon" />
                                <Text className={style.btn} text="Add New Location" />
                            </div>
                        </Container>
                    </div>
                    <Container>
                        <Text text="Saved Address" className={style.address_title} />
                        <Container className={style.addressCard}>
                            {formattedAddress && formattedAddress.length ? (
                                formattedAddress.map(
                                    (address: any, index: number) => {
                                        return (
                                            <>
                                                <AddressCard
                                                    count={index + 1}
                                                    key={index + 1}
                                                    leftSideIcon="/images/home.png"
                                                    // rightSideBadgeText="Saved"
                                                    address={{ ...address, location: { type: "Point", coordinates: [address?.location?.longitude, address?.location?.latitude] } }}
                                                    handleAddressSelection={handleCustomAddressSelection}
                                                    selectedAddress={null}
                                                    rightSideBadgeText={["Partnered"]}
                                                    pickupLocation={pickupLocation}
                                                />
                                            </>
                                        );
                                    }
                                )
                            ) : (
                                <>No Address Found</>
                            )}
                        </Container>
                    </Container>
                    {isOpen && <AddressModal
                        isOpen={isOpen}
                        onClose={handleCancel}
                        address1={address1}
                        setAddress1={setAddress1}
                        address2={address2}
                        setAddress2={setAddress2}
                        landmark={landmark}
                        setLandmark={setLandmark}
                        ambulanceAvailable={ambulanceAvailable}
                        setAmbulanceAvailable={setAmbulanceAvailable}
                        liftAvailable={liftAvailable}
                        setLiftAvailable={setLiftAvailable}
                        autocompleteSuggestions={autocompleteSuggestions}
                        handleInputChange={handleInputChange}
                        handleSuggestionClick={handleSuggestionClick}
                        saveAddress={saveAddress}
                    />}
                </Container>
            </BackgroundWrapper>
        </>
    );
};
